import { combineReducers } from "@reduxjs/toolkit"
import auth from "./authSlice"
import data from "./dataSlice"
import masterSubAccount from "./masterSubAccountSlice"

const allReducers = combineReducers({ 
  auth, 
  data, 
  masterSubAccount 
})

export default allReducers
